import { createContext, useContext, useState, ReactNode } from "react"
import { TranslationContextType, Locale } from "./types"
import en from "./locale/en.json"
import nl from "./locale/nl.json"

const translations = { en, nl }
const TranslationContext = createContext<TranslationContextType | undefined>(
  undefined
)

interface TranslationProviderProps {
  children: ReactNode
}

export const TranslationProvider = ({ children }: TranslationProviderProps) => {
  const [locale, setLocale] = useState<Locale>("nl")

  const t = (key: string, options?: { returnObjects?: boolean }) => {
    const result = key
      .split(".")
      .reduce((obj: any, part: string) => obj?.[part], translations[locale])

    if (options?.returnObjects) {
      return result
    }

    return result || key
  }

  return (
    <TranslationContext.Provider value={{ t, locale, setLocale }}>
      {children}
    </TranslationContext.Provider>
  )
}

export const useTranslation = (): TranslationContextType => {
  const context = useContext(TranslationContext)
  if (context === undefined) {
    throw new Error("useTranslation must be used within a TranslationProvider")
  }
  return context
}
